import { v4 as uuidv4 } from 'uuid'
const Images = [
    {
        category: "Shopping Site", 
        imgsrc: "./Images/website_images/IMG_20240122_113954_166.jpg",
        title: "Poster",
        id: uuidv4(),
        link: "https://nobsownshop.netlify.app", 
    },
    /*{
        category: "Shopping Site", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Shopping Site", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Shopping Site", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Shopping Site", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Shopping Site", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Shopping Site", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Shopping Site", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Shopping Site", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Shopping Site", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Shopping Site", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Shopping Site", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Shopping Site",
        imgsrc: "./Images/website_images/",
        title: "Poster",
        id: uuidv4(),
        link: "",
    },*/
    /*{
        category: "Shopping Site",
        imgsrc: "./Images/website_images/",
        title: "Poster",
        id: uuidv4(),
        link: "",
    },*/
]
export default Images
